const downloadBlob = (fileName: string, blob: Blob) => {
    const tempLink = document.createElement('a');
    tempLink.href = window.URL.createObjectURL(blob);
    tempLink.setAttribute('download', fileName);
    tempLink.click();
    tempLink.remove();
};

export default downloadBlob;
